import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { hasActiveSession } from '@auth/utils/session';

export const accesoLoginGuard: CanActivateFn = (_route, _state) => {

  const router = inject(Router)

  if (hasActiveSession()) {
    router.navigate(['atajos'])
    return false
  }

  return true
}
